import { getFirstQueryParam } from '@/utils'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

const useFirstRouterQueryParam = (keys: string[]) => {
  const router = useRouter()

  const params = useMemo(
    () =>
      keys.map((key) => {
        const value = getFirstQueryParam(router.query[key])

        return value
      }),
    [keys.map((key) => router.query[key])],
  )

  return params
}

export default useFirstRouterQueryParam
